




















import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { createComment } from '@/services/api.service';
import { IUser } from '@/lib/interfaces';

@Component({
  computed: mapState(['users']),
})
export default class CommentRow extends Vue {
  /** users from vuex */
  public users!: { string: IUser };

  private value: string = '';

  private get trimmedValue(): string {
    return this.value.trim();
  }

  /** Когда создаем комментарий */
  private async onCreateComment() {
    const response = await createComment(this.$route.query.issue_id as string, {
      value: this.trimmedValue,
    });
    this.$emit('updateComments', response);
    this.value = '';
  }
}
